import './TicketGroup.less';

import clsx from 'clsx';
import React from 'react';

import useTicketDetail from '@/_hooks/useTicketDetail';
import SwipeableTicket from '@/mytickets/components/swipeable-ticket/SwipeableTicket';

export default function TicketGroup({ className, label, description, tickets, children }) {
    const template = children;
    const onClick = useTicketDetail(tickets?.toJS());
    return tickets && tickets.size ? (
        <section className={clsx('ticket-group', className)}>
            <h2>{label}</h2>
            {description ? <p>{description}</p> : null}
            {tickets.map(t => {
                const ticket = t.toJS();
                const key = ticket.ticketId;

                return template ? (
                    React.cloneElement(template, { key, ticket, onClick })
                ) : (
                    <SwipeableTicket key={key} ticket={ticket} tickets={tickets} onClick={onClick} />
                );
            })}
        </section>
    ) : null;
}
